import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.seek.com',
    clientDomain: 'id.jobstreet.com',
    clientId: '8OVhpvtaI9n5QVEQK3X5yfsmCbrrLXfE',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://id.jobstreet.com/contact-us/',
        id: 'https://id.jobstreet.com/id/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.id,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.id),
    product: Product.SEEK,
};
//# sourceMappingURL=id_jobstreet_com.js.map